(function () {
    angular.module('tradersyard').component('tySpeakerHallSwiper', {
        // language=HTML
        template: `                
            <div class="row speaker-plans" ng-if="$ctrl.node.speaker_halls.length">
                <div class="c-12">
                    <h2>Speaker Plan</h2>

                    <div class="speaker-days-selection">
                        <button
                            ng-repeat="(index, day) in $ctrl.getExhibitionDays()"
                            class="day-button {{ $ctrl.getCurrentDateForExhibition() === day ? 'active' : ''}}"
                            id="day-button-{{index}}"
                            ng-click="$ctrl.openSpeakerHallDay(index)"
                        >{{day}}</button>
                    </div>


                    <div ng-repeat="(index, day) in $ctrl.getExhibitionDays()"
                         id="hall-day-{{index}}" class="exhibition-days"
                         ng-style="{display: $ctrl.getCurrentDateForExhibition() === day ? 'block' : 'none'}"
                    >
                        <div class="row speaker-hall-row" style="width: 90%;">
                            <div class="speaker-hall-time" style="left:-50px;">
                                <div class="speaker-grid speaker-grid-header" style="grid-template-columns: 50px;">
                                    <div class="grid-item">
                                        <div class="addition-hall-info">
                                            <b ng-bind="day"></b>
                                        </div>
                                    </div>
                                </div>

                                <div class="speaker-grid" style="grid-template-columns: 50px;">
                                    <div class="grid-item"
                                         ng-repeat="(key, item) in $ctrl.range(18)"
                                         ng-style="{height: (webinar.duration / 30) * 180 + 'px'}"
                                    >
                                        <div class="addition-hall-info">
                                            <span ng-bind="$ctrl.showTimePeriod(key)"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Swiper -->
                            <div class="swiper-container {{ $ctrl.randomClassName + index }}">
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>

                                <!-- Add Arrows -->
                                <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div>
                            
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide c-4" ng-repeat="(key, speakerHall) in $ctrl.node.speaker_halls">
                                        <div class="speaker-grid speaker-grid-header" ng-style="$ctrl.getGridColumnStyles(1)">
                                            <div class="grid-item">
                                                <div class="hall-block" ng-style="$ctrl.fillBackgroundColor(speakerHall.header_color)">
                                                    {{speakerHall.name}}
                                                    <span class="hall-number" ng-style="{color: speakerHall.header_color}">
                                                    {{ key + 1 }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="speaker-grid" ng-style="$ctrl.getGridColumnStyles(1)">
                                            <div class="grid-item"
                                                 ng-repeat="(key, item) in $ctrl.range(18)"
                                                 ng-init="webinar = $ctrl.findWebinarByTime(speakerHall.id, key, day);"
                                                 ng-if="!$ctrl.reservedKeys[day][speakerHall.id] || $ctrl.reservedKeys[day][speakerHall.id].indexOf(key) === -1"
                                                 ng-style="{height: (webinar.duration / 30) * 180 + 'px'}"
                                            >
                                                <div class="hall-block"
                                                     ng-style="$ctrl.fillBackgroundColor(speakerHall.background_color, speakerHall.header_color, webinar)"
                                                >
                                                    <div class="select-time" ng-if="!webinar && $ctrl.node.make_event_access == true && !$ctrl.eventIsEnded">
                                                        <ty-select-box
                                                            day="day"
                                                            time-period="$ctrl.showTimePeriod(key)"
                                                            speaker-hall="speakerHall.id"
                                                        />
                                                    </div>
        
                                                    <div ng-if="webinar" class="webinar-block">
                                                        <ty-webinar-widget
                                                            is-authorized="$ctrl.isAuthorized"
                                                            webinar="webinar"
                                                        ></ty-webinar-widget>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="speaker-hall-time" style="right:-50px;">
                                <div class="speaker-grid speaker-grid-header" style="grid-template-columns: 50px;">
                                    <div class="grid-item">
                                        <div class="addition-hall-info">
                                            <b ng-bind="day"></b>
                                        </div>
                                    </div>
                                </div>

                                <div class="speaker-grid" style="grid-template-columns: 50px;">
                                    <div class="grid-item"
                                         ng-repeat="(key, item) in $ctrl.range(18)"
                                         ng-style="{height: (webinar.duration / 30) * 180 + 'px'}"
                                    >
                                        <div class="addition-hall-info">
                                            <span ng-bind="$ctrl.showTimePeriod(key)"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="current-timeline" ng-style="{top: $ctrl.getCurrentTimelinePosition()}"></div>
                        </div>
                    </div>
                </div>
            </div>
        `,
        bindings: {
            node: '<',
            isAuthorized: '<',
        },
        transclude: true,
        controller: SpeakerHallSwiperCtrl,
    });

    SpeakerHallSwiperCtrl.$inject = ['$scope', '$timeout', 'datetime-common'];

    function SpeakerHallSwiperCtrl($scope, $timeout, $common) {
        const ctrl = this;

        ctrl.speakerHallPeriod = 180;
        ctrl.selectedDay = 0;
        ctrl.eventIsEnded = false;
        ctrl.swipers = [];

        $scope.onChangeSelectBox = function (timeInMinutes, timePeriod, speakerHallId, day) {
            var encodedPostData = btoa(
                JSON.stringify({
                    exhibition_id: ctrl.node.id,
                    duration: timeInMinutes,
                    speaker_hall_id: speakerHallId,
                    start_time: moment(timePeriod, 'HH:mm A').format('HH:mm'),
                    start_date: moment(day, 'Do MMMM').format('YYYY-MM-DD'),
                })
            );

            window.location.replace(`/webinar/create?exhibition=${encodedPostData}`);
        };

        ctrl.range = function (count, start = 0) {
            return [...Array(Math.ceil(count)).keys()].filter(function (key) {
                return key >= start;
            });
        };

        ctrl.openSpeakerHallDay = function (index) {
            ctrl.selectedDay = index;

            var classes = document.getElementsByClassName('exhibition-days');
            var dayButtons = document.getElementsByClassName('day-button');

            for (var i = 0; i < classes.length; i++) {
                classes[i].style.display = 'none';
                dayButtons[i].classList.remove('active');
            }

            var buttonClassItem = document.getElementById('day-button-' + index);
            buttonClassItem.classList.add('active');

            document.getElementById('hall-day-' + index).style.display = 'block';

            $timeout(function () {
                ctrl.initSwiper();
            }, 50);
        };

        ctrl.reservedKeys = [];

        ctrl.findWebinarByTime = function (speakerHallId, key, currentDate) {
            var webinars = ctrl.node.webinars['speaker_hall_' + speakerHallId];

            var time = ctrl.showTimePeriod(key);

            if (webinars && webinars.length) {
                for (var i = 0; i < webinars.length; i++) {
                    var webinar = webinars[i];

                    var started_at = moment(webinar.started_at);
                    var startedAtDate = started_at.format('Do MMMM');

                    if (startedAtDate === currentDate && started_at.format('HH:mm A') === time) {
                        var ended_at = moment(webinar.ended_at);
                        var duration = $common.duration(started_at, ended_at);

                        webinar.duration = duration.minutes() + duration.hours() * 60;

                        if (typeof ctrl.reservedKeys[currentDate] === 'undefined') {
                            ctrl.reservedKeys[currentDate] = [];
                        }
                        if (typeof ctrl.reservedKeys[currentDate][speakerHallId] === 'undefined') {
                            ctrl.reservedKeys[currentDate][speakerHallId] = [];
                        }

                        ctrl.reservedKeys[currentDate][speakerHallId] = ctrl.reservedKeys[currentDate][
                            speakerHallId
                        ].concat(ctrl.range(key + webinar.duration / 30, 1 + key));

                        return webinar;
                    }
                }
            }

            return undefined;
        };

        ctrl.getGridColumnStyles = function (countColumns, rowGap) {
            return {
                'grid-template-columns': ctrl
                    .range(countColumns)
                    .map(function (item) {
                        if (typeof rowGap !== 'undefined') {
                            return 'calc(' + (100 - rowGap * (countColumns - 1)) / countColumns + '%)';
                        }

                        return 100 / countColumns + '%';
                    })
                    .join(' '),
            };
        };

        ctrl.fillBackgroundColor = function (backgroundColor, borderColor, webinar) {
            var styles = {
                'background-color': backgroundColor,
            };

            if (typeof borderColor !== 'undefined') {
                var leftBorder = '1px';

                if (typeof webinar !== 'undefined') {
                    leftBorder = '5px';
                }

                styles = Object.assign({}, styles, {
                    'border-left': leftBorder + ' solid ' + borderColor,
                    'border-right': '1px solid ' + borderColor,
                });
            }

            return styles;
        };

        ctrl.showTimePeriod = function (key) {
            var startFromHour = 10;
            key = 0.5 * key;

            var addHours = Math.floor(key);
            var totalHours = startFromHour + addHours;

            var minutes = addHours < key ? '30' : '00';
            var timePeriod = totalHours >= 12 ? 'PM' : 'AM';

            return moment(`${totalHours}:${minutes} ${timePeriod}`, 'HH:mm A').format('HH:mm A');
        };

        ctrl.getCurrentTimelinePosition = function () {
            var height = 45;
            var pixelsForOneMinute = ctrl.speakerHallPeriod / 60;

            var startTime = moment(moment().format('YYYY-MM-DD') + ' ' + '10:00 AM');
            var currentTime = moment();

            var duration = moment.duration(currentTime.diff(startTime));

            height = height + duration.hours() * (ctrl.speakerHallPeriod * 2) + pixelsForOneMinute * duration.minutes();

            if (height < 45) {
                return 45;
            }

            if (height > 3285) {
                return 3285;
            }

            return height + 'px';
        };

        ctrl.getExhibitionDays = function () {
            var daysList = [];

            var started_at = moment(ctrl.node.exhibition_started_at),
                ended_at = moment(ctrl.node.exhibition_ended_at);

            var duration = $common.duration(started_at, ended_at).days() + 1;

            ctrl.range(duration).forEach((day) =>
                daysList.push(moment(ctrl.node.exhibition_started_at).add(day, 'days').format('Do MMMM'))
            );

            return daysList;
        };

        ctrl.getCurrentDateForExhibition = function () {
            var startedAt = moment(ctrl.node.exhibition_started_at);
            var endedAt = moment(ctrl.node.exhibition_ended_at);
            var currentDate = moment();

            if (currentDate.diff(startedAt, 'days') >= 0 && currentDate.diff(endedAt, 'days') <= 0) {
                return moment().format('Do MMMM');
            }

            if (currentDate.diff(startedAt, 'days') < 0) {
                return startedAt.format('Do MMMM');
            }

            if (currentDate.diff(endedAt, 'days') > 0) {
                return endedAt.format('Do MMMM');
            }
        };

        ctrl.randomClassName = 'speaker-hall-' + moment().format('x') + Math.floor(Math.random() * 100);

        ctrl.initSwiper = function () {
            ctrl.swipers[ctrl.selectedDay] = new Swiper(`.${ctrl.randomClassName + ctrl.selectedDay}`, {
                slidesPerView: 1,
                spaceBetween: 5,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                    },
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                    },
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                    },
                    1300: {
                        slidesPerView: 3,
                        spaceBetween: 5,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        };

        ctrl.$onInit = function () {
            var listDays = ctrl.getExhibitionDays();
            ctrl.selectedDay = listDays.indexOf(ctrl.getCurrentDateForExhibition());

            ctrl.eventIsEnded = moment(ctrl.node.exhibition_ended_at).unix() < moment().unix();

            $timeout(function () {
                ctrl.initSwiper();
            });

            $timeout(function () {
                $(`.swiper-container`).mouseenter(function () {
                    if (typeof ctrl.swipers[ctrl.selectedDay] !== 'undefined') {
                        ctrl.swipers[ctrl.selectedDay].autoplay.stop();
                    }
                });

                $(`.swiper-container`).mouseleave(function () {
                    if (typeof ctrl.swipers[ctrl.selectedDay] !== 'undefined') {
                        ctrl.swipers[ctrl.selectedDay].autoplay.start();
                    }
                });
            });
        };
    }
})();
